export enum ResourcePageEnum {
  INVENTORY = "Inventory",
  CHECKLIST = "Checklist & Forms",
  FLEET = "Fleet",
  STAFF = "Staff",
  SERVICES = "Services",
  INSTRUCTIONS = "Instructions",
  ACCESS = "Access",
  MATERIAL = "Materials",
  PROJECTS = "Projects",
  EQUIPMENTS = "Equipments",
  SUBCONTRACTORS = "Subcontractors",
}
